export type IntensityVariant = 'orange' | 'blue'

export type MuscleEntry = {
  key: string
  intensity: number
}

export const INTENSITY_DOTS = 5
export const INTENSITY_MAX = 10

const ORANGE_COLORS = [
  'transparent', // 0
  '#FDD3C0', // 1-2: very light peach
  '#FABB98', // 3-4: light salmon
  '#F4A37E', // 5-6: medium orange
  '#EE8B64', // 7-8: strong orange
  '#E8734A', // 9+: vivid orange
]

const BLUE_COLORS = [
  'transparent', // 0
  '#C0DDFB', // 1-2: very light blue
  '#98C8FA', // 3-4: light blue
  '#7EB4F4', // 5-6: medium blue
  '#649AEE', // 7-8: strong blue
  '#4A8DE8', // 9+: vivid blue
]

export const getIntensityColor = (
  variant: IntensityVariant,
  intensity?: number
) => {
  const palette = variant === 'orange' ? ORANGE_COLORS : BLUE_COLORS

  if (!intensity || intensity === 0) {
    return palette[0]
  }
  if (intensity <= 2) {
    return palette[1]
  }
  if (intensity <= 4) {
    return palette[2]
  }
  if (intensity <= 6) {
    return palette[3]
  }
  if (intensity <= 8) {
    return palette[4]
  }
  return palette[5]
}

export const getActiveDots = (intensity: number) => {
  return Math.ceil((intensity / INTENSITY_MAX) * INTENSITY_DOTS)
}
